module.exports = ".lang-circle {\n  width: 42px;\n  height: 42px;\n  border: 2px solid maroon;\n  border-radius: 23px;\n  top: 29.64px;\n  background-color: #ff524f;\n  color: white;\n  font-size: 15.33333333px;\n  padding: 8px;\n  position: absolute;\n  font-weight: 900;\n  cursor: pointer; }\n\n.lang-circle:hover {\n  background-color: #ff625f; }\n\n.lang-de {\n  margin: 0 0 0 400px; }\n\n.lang-fr {\n  margin: 0 0 0 450px; }\n\n.lang-en {\n  margin: 0 0 0 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/top-bar/lang-switcher/lang-switcher.component.scss
// module id = ./src/app/top-bar/lang-switcher/lang-switcher.component.scss
// module chunks = main